import { render, staticRenderFns } from "./FormBodyRepeater.vue?vue&type=template&id=ddd1494e&scoped=true&"
import script from "./FormBodyRepeater.vue?vue&type=script&lang=js&"
export * from "./FormBodyRepeater.vue?vue&type=script&lang=js&"
import style0 from "./FormBodyRepeater.vue?vue&type=style&index=0&id=ddd1494e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd1494e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
